import React from 'react';
import { CMS_LOCATION } from '../../constants/constants';

const EquipmentToBeReturn = ({ EQData, ERDynamicData }) => {
    let eqDeviceName = "";
    return (
        <div className="panel padding-bottom-zero">
            {EQData.eqreturndellist && <h5>{EQData.eqreturndellist[0].equipments}</h5>}
            <div className="row w_return-status medium-vert-middle">
                {
                    ERDynamicData.equipDetails.map((item, index) => {
                        let device = item.EquipType.toLowerCase();
                        if (device.indexOf("arris") > -1 || device.indexOf("ipc") > -1) {
                            eqDeviceName = "Arris_IPC_1100.jpg";
                            } else if (device.indexOf("bhr") > -1 ) {
                                eqDeviceName = "bhr3image.jpg";
                            } else if (device.indexOf("cable")  > -1 || device.indexOf("card") > -1) {
                                eqDeviceName = "Cable_Card.jpg";
                            } else if (device.indexOf("digital") > -1 && device.indexOf("adapter") > -1) {
                                eqDeviceName = "Digital-Adapter.png";
                            } else if (device.indexOf("dvr") > -1 && device.indexOf("plus") > -1) {
                                eqDeviceName = "dvr-plus-box.png";
                            } else if (device.indexOf("dvr") > -1 ) {
                                eqDeviceName = "DVR_CCF12017.jpg";
                            } else if (device.indexOf("media") > -1 && device.indexOf("client") > -1) {
                                eqDeviceName = "Media_Client.jpg";
                            } else if (device.indexOf("ont") > -1 && device.indexOf("ipc") > -1) {
                                eqDeviceName = "ONT-Box.png";
                            } else if (device.indexOf("power") > -1 && device.indexOf("cords") > -1) {
                                eqDeviceName = "Power-Cords.png";
                            } else if (device.indexOf("printer") > -1 ) {
                                eqDeviceName = "printer.png";
                            } else if (device.indexOf("remote") > -1 && device.indexOf("cables") > -1) {
                                eqDeviceName = "Remote-Cables.png";
                            } else if ((device.indexOf("router") > -1 )) {
                                eqDeviceName = "router.png";
                            } else if (device.indexOf("set-top") > -1 ) {
                                eqDeviceName = "Set-Top-Box.png";
                            } else if (device.indexOf("video media server") > -1 ) {
                                eqDeviceName = "VMS.png";
                            } else if((device.toLowerCase().indexOf("fios") > -1 )) {
                                eqDeviceName = "fios_quantum_router.png";
                            }

                        return <div className="column medium-6 return-status_equiment" key={index}>
                            <div className="row medium-vert-middle p-100">
                                <div className="column return-status_equip-image">
                                    <figure className="margin-all-zero">
                                        <img className="eqreturn_image" alt={eqDeviceName} src={CMS_LOCATION + "/content/dam/verizon/support/consumer/images/er/" + eqDeviceName}></img>
                                        <figcaption>{item.EquipType}</figcaption>
                                    </figure>
                                </div>
                                <div className="column medium-8">
                                    <ul>
                                        <li data-cs-mask className="no-bullet margin-bottom-zero">
                                            <strong> Model: </strong>
                                            {item.Model}
                                        </li>
                                        <li data-cs-mask className="no-bullet margin-bottom-zero">
                                            <strong> Serial: </strong>
                                            {item.SerialNumber}
                                        </li>
                                        <li data-cs-mask className="no-bullet margin-bottom-zero">
                                            <strong> Return Status: </strong>
                                            {item.ReturnEquip}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    })
                }
            </div>
        </div>
    )
}

export default EquipmentToBeReturn


// WEBPACK FOOTER //
// ./src/components/modules/EquipmentsToReturn.js